import React from 'react';
import clsx from 'clsx';
import * as styles from '../Cart.module.css';
import ContentfulTranslationText from '../../../atoms/ContentfulTranslationText/ContentfulTranslationText';

const CartHeader = () => {
  return (
    <div className={styles.bcCartHeader}>
      <div
        className={clsx(styles.bcCartHeaderLabel, styles.bcCartHeaderItemCol)}
      >
        <ContentfulTranslationText keyName="item">Item</ContentfulTranslationText>
      </div>
      <div className={styles.bcCartDetils}>
        <div className={styles.bcCartHeaderLabel}><ContentfulTranslationText keyName="priceEach">Price each</ContentfulTranslationText></div>
        <div className={`${styles.bcCartHeaderLabel} text-center`}><ContentfulTranslationText keyName="quantity">Quantity</ContentfulTranslationText></div>
        <div className={styles.bcCartHeaderLabel}><ContentfulTranslationText keyName="total">Total</ContentfulTranslationText></div>
      </div>
    </div>
  );
};

export default CartHeader;
